// Время в админке блога показываем и вводим в МСК (UTC+3, без перехода на летнее время с 2014),
// в API — ISO UTC. Не зависит от часового пояса браузера редактора.
const MSK_OFFSET_MS = 3 * 60 * 60 * 1000;

/** ISO UTC → значение для <input type="datetime-local"> в МСК («YYYY-MM-DDTHH:mm»). */
export function isoToMskInput(iso: string | null | undefined): string {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return '';
  return new Date(t + MSK_OFFSET_MS).toISOString().slice(0, 16);
}

/** «YYYY-MM-DDTHH:mm» в МСК → ISO UTC; пусто/битое → null. */
export function mskInputToIso(value: string): string | null {
  const m = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
  if (!m) return null;
  const [, y, mo, d, h, mi] = m.map(Number);
  return new Date(Date.UTC(y, mo - 1, d, h, mi) - MSK_OFFSET_MS).toISOString();
}

/** «21.10.2026, 22:00 МСК». */
export function formatMsk(iso: string | null | undefined): string {
  const v = isoToMskInput(iso);
  if (!v) return '—';
  const [date, time] = v.split('T');
  const [y, mo, d] = date.split('-');
  return `${d}.${mo}.${y}, ${time} МСК`;
}
